import { Constants } from "../../data/constants";
import { HttpService } from "../../utils/HttpService";

export class CfgUserService {
  constructor() {
    this.constants = new Constants();
    this.HttpService = new HttpService();
  }

  editCfgUser = async (session_id, CfgUSer) => {
    try {
      return await this.HttpService.putJson(
        this.constants.cfgUserServicesURLs.editCfgUser,
        {
          key: CfgUSer.key,
          value: CfgUSer.value,
          configCategory: CfgUSer.configCategory,
          userId: CfgUSer.userId,
          changeStatusFrom: CfgUSer.changeStatusFrom,
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  getCfgUser = async (session_id, userId, category, key) => {
    try {
      return await this.HttpService.getJson(
        this.constants.cfgUserServicesURLs.getCfgUser +
          `userId/${userId}/category/${category}/key/${key}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  getOnlineAvailability = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.cfgUserServicesURLs.getAvailability,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
}
